import { __ } from './gettext'

export { __, getLocale, setLocale, initI18n, setLocaleHeader } from './gettext'
export default __
